import {TaskState} from "../models/TaskState";
import {AbstractFactory} from "../framework/AbstractFactory";
import {TASK} from "../constants/TaskConstants";
import {TASK_TYPES} from "../constants/TaskTypes";
import {OBJECT_TYPES as OBJECT_TYPE} from "../constants/ObjectTypes";
import {workUint64} from "../util/WorkDifficulty";

export class TaskStateFactory extends AbstractFactory {

  /**
   * @param {object} obj
   * @return {TaskState}
   */
  make(obj) {
    const task_state = new TaskState();
    Object.assign(task_state, obj);

    return task_state;
  }


  /**
   * @param {string} fleet_id
   * @param {string} planet_id
   * @param {number} block_start
   * @param {number} difficulty_target
   * @return {TaskState}
   */
  initRaidTask(fleet_id, planet_id, block_start, difficulty_target){

    const task_state = new TaskState();

    task_state.task_type = TASK_TYPES.RAID;
    task_state.object_type = OBJECT_TYPE.FLEET;
    task_state.object_id = fleet_id;
    task_state.target_id = planet_id;
    task_state.block_start = String(workUint64(block_start));
    task_state.difficulty_target = String(workUint64(difficulty_target));

    task_state.prefix = task_state.object_id + TASK.TARGET_DELIMITER + task_state.target_id + task_state.task_type + task_state.block_start + TASK.NONCE_PREFIX;
    task_state.postfix = '';

    return task_state;
  }



  /**
   * @param {string} struct_id
   * @param {string} task_type
   * @param {number} block_start
   * @param {number} difficulty_target
   * @return {TaskState}
   */
  initStructTask(struct_id, task_type, block_start, difficulty_target){

    const task_state = new TaskState();

    task_state.task_type = task_type;
    task_state.object_type = OBJECT_TYPE.STRUCT;
    task_state.object_id = struct_id;
    task_state.block_start = String(workUint64(block_start));
    task_state.difficulty_target = String(workUint64(difficulty_target));

    task_state.prefix = task_state.object_id  + task_state.task_type + task_state.block_start + TASK.NONCE_PREFIX;
    task_state.postfix = '';

    return task_state;
  }

  /**
   * @param {Work} work
   * @return {TaskState}
   */
  initTaskFromWork(work) {
    let task;
    switch(work.category) {
      case TASK_TYPES.RAID:
        task = this.initRaidTask(work.object_id, work.target_id, work.block_start, work.difficulty_target);
        break;
      case TASK_TYPES.BUILD:
      case TASK_TYPES.MINE:
      case TASK_TYPES.REFINE:
        task = this.initStructTask(work.object_id, work.category, work.block_start, work.difficulty_target);
        break;
      default:
        throw new Error(`Unknown task type: ${work.category}`);
    }
    if (work.snapshot_meta?.height != null) task.rules_height = String(workUint64(work.snapshot_meta.height));
    return task;
  }


}
